import * as React from "react";
import { forwardRef } from "react";
const SvgClose12 = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 12 12", fill: "none", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 1L11 11M11 1L1 11", stroke: "currentColor", strokeWidth: 2, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgClose12);
export default ForwardRef;
